import { RuleActionApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { uid } from '../../../../lib/helpers/uid';
import { ActionType } from '../../rules/ActionType';
import { getItemValueForAction } from './getItemValueForAction';

export function generateActionsForInlineRule(item: SmartSendItemApiModel, actions: string[]): RuleActionApiModel[] {
  return actions.map((a) => ({
    Field: a,
    Type: ActionType.Replace,
    Value: getItemValueForAction(item, a),
    Id: uid()
  }));
}
